module.exports = "<%=baseUrl%>/4b76590b32dab62bc95c1b7951efae78.swf";


//////////////////
// WEBPACK FOOTER
// ./src/playbacks/flash/public/Player.swf
// module id = 188
// module chunks = 0